import React, { Component } from 'react';
import { MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBIcon, MDBRow, MDBCol, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact';
import axios from 'axios';
import ConfigData from '../Components/config';
import AppDataTable from '../Components/AppDataTable';

export default class showcertificateVicerector extends Component {

    constructor(props) {
        super(props)
        this.state = {
            modaldisallow: false,
            countShowReportPetition: 0,
            id_citifacate: null,
            REASONS: null,
            modalupdate: false,

            array_ShowReportPetition: [],
        }
        this.Update = this.Update.bind(this);
        this.handleReasonChange = this.handleReasonChange.bind(this);
        this.modaldisallow_open = this.modaldisallow_open.bind(this);
        this.modaldisallow_close = this.modaldisallow_close.bind(this);
    }

    componentDidMount() {
        if (!(localStorage.getItem('token'))) {
            window.location.href = '/rubrongkpru'
        }
        axios.get(ConfigData.SERVER_URL + 'FrontEnd_Tabian/petition/ShowReportCertificateVicerector/').then((ShowReportPetition) => {
            if (ShowReportPetition.data.length !== 0) {
                var i = 0;
                while (i < ShowReportPetition.data.length) {
                    ShowReportPetition.data[i]['Index'] = i + 1;
                    if (ShowReportPetition.data[i]['STATUS_VICERECTOR_PRESIDENT'] === null) {
                        ShowReportPetition.data[i]['Statusfill'] = <span>
                            <button className="btn btn-info btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + "," + ShowReportPetition.data[i].ID_NO} onClick={this.showpetition}><MDBIcon icon="eye" /> ตรวจสอบคำร้องขอ</button>
                            <button className="btn btn-primary btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + "," + 1 + "," + ShowReportPetition.data[i].NAME_ENG + "," + ShowReportPetition.data[i].RUBRONG_TYPE} onClick={this.OpenRpt} hidden={ShowReportPetition.data[i].NUM_RUBRONGTH > '0' ? false : true}><MDBIcon icon="print" /> ดูใบรับรองภาษาไทย</button>
                            <button className="btn btn-secondary btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + "," + 2 + "," + ShowReportPetition.data[i].NAME_ENG + "," + ShowReportPetition.data[i].RUBRONG_TYPE} onClick={this.OpenRpt} hidden={ShowReportPetition.data[i].NUM_RUBRONGEN > '0' ? false : true}><MDBIcon icon="print" /> ดูใบรับรองอังกฤษ</button>
                            <button className="btn btn-success btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + "," + 1} onClick={this.Update}><MDBIcon icon="money-bill" /> อนุมัติคำร้องขอ</button>
                            <button className="btn btn-danger btn-sm" value={ShowReportPetition.data[i].ID_NUMBER} onClick={this.modaldisallow_open}><MDBIcon icon="ban" /> ไม่อนุมัติคำร้องขอ</button>
                        </span>
                    }
                    i++;
                }
                this.setState({
                    array_ShowReportPetition: {
                        columns: [
                            { label: '#', field: 'Index', },
                            { label: 'วันที่ร้องขอ', field: 'DATE_INSERT', },
                            { label: 'รหัสนักศึกษา', field: 'OLDID', },
                            { label: 'ชื่อ-นามสกุล', field: 'NAME', },
                            { label: 'ขอใบรับรองเรื่อง', field: 'TYPEPITITION_NAME', },
                            { label: 'ภาษาไทย', field: 'NUM_RUBRONGTH', },
                            { label: 'ภาษาอังกฤษ', field: 'NUM_RUBRONGEN', },
                            { label: 'สถานะ', field: 'Statusfill', },
                        ],
                        rows: ShowReportPetition.data
                    }
                })
                this.setState({ countShowReportPetition: ShowReportPetition.data.length });
            }
        })
    }

    modaldisallow_open(event) {
        event.preventDefault();
        this.setState({ modaldisallow: true });
        this.setState({ id_citifacate: event.target.value });
    }

    modaldisallow_close(event) {
        event.preventDefault();
        this.setState({ modaldisallow: false });
        this.setState({ REASONS: null });
        this.setState({ id_citifacate: null });
    }

    showpetition(event) {
        var splitvalue = event.target.value.split(",")
        window.open(
            'https://mua.kpru.ac.th/apipostpone/postponepdf/reportpetition_print.php?idrpt=' + splitvalue[0] + '&ID_NO=' + splitvalue[1],
            '_blank'
        );
    }

    Update(event) {
        var splitvalue = event.target.value.split(",")
        if (splitvalue[1] === "1") {
            this.setState({ modalupdate: true });
        }
        let bodydata = {
            REASONS: this.state.REASONS,
        }
        axios.post(ConfigData.SERVER_URL + 'FrontEnd_Tabian/petition/updatestatusVicerector/' + splitvalue[0] + '/' + splitvalue[1] + "/" + localStorage.getItem('id'), bodydata).then((respone) => {
            if (respone.data === 1) {
                window.location.reload()
                this.setState({ modalupdate: false });
                this.setState({ modaldisallow: false });
                this.setState({ REASONS: null });
                this.setState({ id_citifacate: null });
            }
        });
    }

    handleReasonChange(event) {
        this.setState({ [event.target.name]: event.target.value })
    }

    OpenRpt(event) {
        var splitvalue = event.target.value.split(",");
        if (splitvalue[1] === "1") {
            if (splitvalue[3] === "32" || splitvalue[3] === "33") {
                window.open(
                    "http://e-certificate.kpru.ac.th/RubrongKru.aspx?Id_number=" + splitvalue[0], "_blank"
                );
            } else {
                window.open(
                    // "http://192.168.101.27/Default.aspx?Id_number="+splitvalue[0], "_blank" // 7844 = รหัสใบรับรอง
                    "http://e-certificate.kpru.ac.th/ThaiCertificate.aspx?Id_number=" + splitvalue[0], "_blank"
                );
            }
        } else if (splitvalue[1] === "2") {
            window.open(
                // "http://192.168.101.27/Default.aspx?Id_number="+splitvalue[0], "_blank" // 7844 = รหัสใบรับรอง
                "http://e-certificate.kpru.ac.th/EngCertificate.aspx?Id_number=" + splitvalue[0], "_blank"
            );
        }
    }

    render() {
        return (<>
            <span className="white-text mt-3" style={{ fontSize: '22px' }}>สถานะการขอเอกสารทางการศึกษา</span><span className="white-text mt-3" style={{ fontSize: '16px' }}> มหาวิทยาลัยราชภัฏกำแพงเพชร</span>

            <MDBRow>
                <MDBCol lg="12" md="12" sm="12">
                    <MDBCard className="mt-3">
                        <MDBCardBody>
                            <MDBCardTitle className="h5">
                                สถานะการขอเอกสารทางการศึกษา
                            </MDBCardTitle>
                            <MDBCardText>
                                {this.state.countShowReportPetition === 0 ? <>
                                    <span className="text-danger">ไม่มีข้อมูลการขอเอกสารทางการศึกษา</span>
                                </> : <>
                                    <AppDataTable data={this.state.array_ShowReportPetition} />
                                </>}
                            </MDBCardText>
                        </MDBCardBody>
                    </MDBCard>
                </MDBCol>
            </MDBRow>

            <MDBModal isOpen={this.state.modalupdate} size="md" centered>
                <MDBModalBody className="text-align">
                    <div class="spinner-border text-success" style={{ width: "36px", height: "36px" }} role="status"></div>
                    <br />
                    <span style={{ fontSize: "18px" }}>
                        ระบบกำลังดำเนินการสร้างเอกสารทางการศึกษา&nbsp;
                    </span>
                </MDBModalBody>
            </MDBModal>

            <MDBModal isOpen={this.state.modaldisallow} toggle={this.modaldisallow_close} centered>
                <MDBModalHeader toggle={this.modaldisallow_close}>รายละเอียดที่ไม่อนุมัติคำร้องขอ</MDBModalHeader>
                <MDBModalBody>
                    <div className="form-outline mt-2">
                        <label className="form-label" for="REASONS">รายละเอียดที่ไม่อนุมัติคำร้องขอ</label>
                        <input type="text" className="form-control" id="REASONS" name="REASONS" placeholder="รายละเอียดที่ไม่อนุมัติคำร้องขอ" value={this.state.REASONS} onChange={this.handleReasonChange} required />
                    </div>
                </MDBModalBody>
                <MDBModalFooter>
                    <button type="button" className="btn btn-primary btn-md" onClick={this.Update} value={this.state.id_citifacate + "," + 0}>บันทึกข้อมูล</button>
                    <button type="button" className="btn btn-danger btn-md" onClick={this.modaldisallow_close}>ยกเลิก</button>
                </MDBModalFooter>
            </MDBModal>
        </>)
    }
}
